import Box from '@mui/material/Box';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';

interface ToggleConfig {
  key: string;
  label: string;
  description: string;
}

const TOGGLES: ToggleConfig[] = [
  {
    key: 'include_user_context',
    label: 'User Context',
    description: 'Include user name and role in the prompt',
  },
  {
    key: 'include_org_context',
    label: 'Organization Context',
    description: 'Include organization name and details',
  },
  {
    key: 'include_prospect_context',
    label: 'Prospect Context',
    description: 'Include prospect name, company, and notes',
  },
  {
    key: 'include_transcript_context',
    label: 'Transcript Context',
    description: 'Include conversation transcript content',
  },
];

interface ContextTogglesPanelProps {
  values: Record<string, boolean>;
  onChange: (key: string, value: boolean) => void;
  disabled?: boolean;
}

export function ContextTogglesPanel({
  values,
  onChange,
  disabled = false,
}: ContextTogglesPanelProps) {
  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        Context Sections
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color: "text.secondary",
          mb: 2
        }}>
        Control which context sections are appended to the prompt at runtime.
      </Typography>
      {TOGGLES.map((toggle) => (
        <Box key={toggle.key} sx={{ mb: 1 }}>
          <FormControlLabel
            control={
              <Switch
                checked={values[toggle.key] ?? true}
                onChange={(e) => onChange(toggle.key, e.target.checked)}
                disabled={disabled}
                size="small"
              />
            }
            label={
              <Box>
                <Typography variant="body2">{toggle.label}</Typography>
                <Typography variant="caption" sx={{
                  color: "text.secondary"
                }}>
                  {toggle.description}
                </Typography>
              </Box>
            }
            sx={{ alignItems: 'flex-start', ml: 0 }}
          />
        </Box>
      ))}
    </Box>
  );
}
